import { getArchivedCaseDetailsPath } from '../../services/legalKnowledgeArchive';

type Props = {
  archiveReferenceNumber: string;
  targetId?: string;
  resolving?: boolean;
};

export function CaseLinkageLink({
  archiveReferenceNumber,
  targetId,
  resolving = false,
}: Props) {
  if (resolving || !targetId) {
    return (
      <span
        className="mfb"
        style={{ textDecoration: 'none', color: 'var(--t3)', cursor: 'default', pointerEvents: 'none' }}
      >
        {archiveReferenceNumber}
      </span>
    );
  }

  return (
    <a
      href={getArchivedCaseDetailsPath(targetId)}
      target="_blank"
      rel="noopener noreferrer"
      className="mfb"
      style={{ textDecoration: 'underline' }}
    >
      {archiveReferenceNumber}
    </a>
  );
}
